import { Declaration } from 'store/declarations/declaration';
import RefundsList from 'views/declarations/refunds/RefundsList';
import RefundsDeposits from 'views/declarations/refunds/RefundsDeposits';
import DepositDeclaration from 'views/declarations/refunds/DepositDeclaration';
import RemissionDeclaration from 'views/declarations/refunds/RemissionDeclaration';
import RefundsRemissions from 'views/declarations/refunds/RefundsRemissions';
import Refunds from 'views/declarations/refunds/Refunds';
import Product from 'views/declarations/declaration-tabs/declaration-form/tabs/products/Product';
import Products from 'views/declarations/declaration-tabs/declaration-form/tabs/products/Products';
import MasterDetails from 'views/declarations/declaration-tabs/declaration-form/tabs/master/MasterDetails';
import DeclarationHistoryTable from 'views/declarations/declaration-tabs/history/DeclarationHistoryTable';
import DeclarationHistory from 'views/declarations/declaration-tabs/history/DeclarationHistory';
import CustomsRequests from 'views/declarations/declaration-tabs/customs-requests/ics2/CustomsRequests';
import DeclarationNotes from 'views/declarations/declaration-tabs/notes/DeclarationNotes';
import CustomerDetails from 'views/customers/components/CustomerDetails';
import Documentation from 'views/declarations/declaration-tabs/documentation/Documentation';
import BarcodeView from 'views/declarations/uk/gvms/components/barcode/BarcodeView';
import SummaryView from 'views/declarations/common/summary-view/SummaryView';
import FormViewOnly from 'views/declarations/declaration-tabs/view-only/FormViewOnly';
import MasterItems from 'views/declarations/declaration-tabs/declaration-form/tabs/master-items/MasterItems';
import DeclarationFormTab from 'views/declarations/declaration-tabs/declaration-form/DeclarationFormTab';
import DeclarationVatAndDuty from 'views/declarations/declaration-tabs/vat-and-duty/DeclarationVatAndDuty';
import DeclarationFormWrapper from 'views/declarations/declaration-tabs/declaration-form/DeclarationFormWrapper';
import { AccessDeniedRoute } from './AccessDeniedRoute';
import { Route } from './ProtectedRoute';
import HouseConsignmentForm from 'views/declarations/declaration-tabs/declaration-form/tabs/house-consignments/HouseConsignmentForm';
import HouseConsignmentsPage from 'views/declarations/declaration-tabs/declaration-form/tabs/house-consignments/HouseConsignmentsPage';
import { hasIcs2MasterItems } from 'views/declarations/eu/ics2/utils';

export const getDeclarationChildren = (declaration: Declaration | undefined): Route[] => {
    const { isGvmsOrPbn, isIcs2Ens, isIcs2EnsWithMasterItems, isDeclarationLoaded } =
        getDeclarationRouteFlags(declaration);
    const ics2EnsCondition = !isDeclarationLoaded || isIcs2Ens;
    const ics2EnsMasterItemsCondition = !isDeclarationLoaded || isIcs2EnsWithMasterItems;

    return [
        {
            path: '',
            name: 'Form tab',
            element: <DeclarationFormTab />,
            children: [
                {
                    path: '',
                    name: 'Form',
                    element: <DeclarationFormWrapper />,
                    children: [
                        {
                            path: '',
                            name: 'Master Details',
                            element: <MasterDetails />,
                            index: true,
                        },
                        {
                            path: 'products',
                            name: 'Products',
                            element: (
                                <AccessDeniedRoute condition={!isGvmsOrPbn}>
                                    <Products />
                                </AccessDeniedRoute>
                            ),
                        },
                        {
                            path: 'products/:productId',
                            name: 'Product Details',
                            element: (
                                <AccessDeniedRoute condition={!(isGvmsOrPbn || isIcs2Ens)}>
                                    <Product />
                                </AccessDeniedRoute>
                            ),
                        },
                        {
                            path: 'master-items',
                            name: 'Master Items',
                            element: (
                                <AccessDeniedRoute condition={ics2EnsMasterItemsCondition}>
                                    <MasterItems />
                                </AccessDeniedRoute>
                            ),
                        },
                        {
                            path: 'master-items/:productId',
                            name: 'Master Item Product details',
                            element: (
                                <AccessDeniedRoute condition={ics2EnsMasterItemsCondition}>
                                    <Product />
                                </AccessDeniedRoute>
                            ),
                        },
                        {
                            path: 'house-consignments',
                            name: 'House Consignments',
                            element: (
                                <AccessDeniedRoute condition={ics2EnsCondition}>
                                    <HouseConsignmentsPage />
                                </AccessDeniedRoute>
                            ),
                        },
                        {
                            path: 'house-consignments/:consignmentId',
                            name: 'House Consignment',
                            element: (
                                <AccessDeniedRoute condition={ics2EnsCondition}>
                                    <HouseConsignmentForm />
                                </AccessDeniedRoute>
                            ),
                        },
                        {
                            path: 'house-consignments/:consignmentId/:productId',
                            name: 'House Consignment Product',
                            element: (
                                <AccessDeniedRoute condition={ics2EnsCondition}>
                                    <Product />
                                </AccessDeniedRoute>
                            ),
                        },
                    ],
                },
                {
                    path: 'view-only',
                    name: 'Form View Only',
                    element: <FormViewOnly />,
                    children: [
                        {
                            path: '',
                            name: 'Master Details',
                            element: <MasterDetails />,
                            index: true,
                        },
                        {
                            path: 'products',
                            name: 'Products',
                            element: (
                                <AccessDeniedRoute condition={!isGvmsOrPbn}>
                                    <Products />
                                </AccessDeniedRoute>
                            ),
                        },
                        {
                            path: 'products/:productId',
                            name: 'Product Detail',
                            element: (
                                <AccessDeniedRoute condition={!isGvmsOrPbn}>
                                    <Product />
                                </AccessDeniedRoute>
                            ),
                        },
                        {
                            path: 'master-items',
                            name: 'Master Items',
                            element: (
                                <AccessDeniedRoute condition={ics2EnsMasterItemsCondition}>
                                    <MasterItems />
                                </AccessDeniedRoute>
                            ),
                        },
                        {
                            path: 'master-items/:productId',
                            name: 'Master Item Product details',
                            element: (
                                <AccessDeniedRoute condition={ics2EnsMasterItemsCondition}>
                                    <Product />
                                </AccessDeniedRoute>
                            ),
                        },
                        {
                            path: 'house-consignments',
                            name: 'House Consignments',
                            element: (
                                <AccessDeniedRoute condition={ics2EnsCondition}>
                                    <HouseConsignmentsPage />
                                </AccessDeniedRoute>
                            ),
                        },
                        {
                            path: 'house-consignments/:consignmentId',
                            name: 'House Consignment',
                            element: (
                                <AccessDeniedRoute condition={ics2EnsCondition}>
                                    <HouseConsignmentForm />
                                </AccessDeniedRoute>
                            ),
                        },
                        {
                            path: 'house-consignments/:consignmentId/:productId',
                            name: 'House Consignment Product',
                            element: (
                                <AccessDeniedRoute condition={ics2EnsCondition}>
                                    <Product />
                                </AccessDeniedRoute>
                            ),
                        },
                    ],
                },
            ],
        },
        {
            path: 'summary',
            name: 'Summary',
            element: <SummaryView />,
            index: true,
        },
        {
            path: 'barcode',
            name: 'Barcode',
            element: <BarcodeView />,
            index: true,
        },
        {
            path: 'documentation',
            name: 'Documentation',
            element: (
                <AccessDeniedRoute condition={!isGvmsOrPbn}>
                    <Documentation />
                </AccessDeniedRoute>
            ),
            index: true,
        },
        {
            path: 'customer-details',
            name: 'Customer Details',
            element: (
                <AccessDeniedRoute condition={!isGvmsOrPbn}>
                    <CustomerDetails />
                </AccessDeniedRoute>
            ),
        },
        {
            path: 'notes',
            name: 'Declaration Notes',
            element: <DeclarationNotes />,
        },
        {
            path: 'customs-requests',
            name: 'Customs Requests',
            element: (
                <AccessDeniedRoute condition={ics2EnsCondition}>
                    <CustomsRequests />
                </AccessDeniedRoute>
            ),
        },
        {
            path: 'history',
            name: 'History',
            element: <DeclarationHistory />,
            children: [
                {
                    path: '*',
                    name: 'History Table',
                    element: <DeclarationHistoryTable />,
                    index: true,
                },
            ],
        },
        {
            path: 'refunds',
            name: 'Refunds',
            element: <Refunds />,
            children: [
                {
                    path: 'remissions',
                    name: 'Remissions',
                    element: <RefundsRemissions />,
                    children: [
                        {
                            path: '',
                            name: 'Remissions List',
                            element: <RefundsList />,
                            index: true,
                        },
                        {
                            path: ':remissionId',
                            name: 'Remission',
                            element: <RemissionDeclaration />,
                            index: true,
                        },
                    ],
                },
                {
                    path: 'deposits',
                    name: 'Deposits',
                    element: <RefundsDeposits />,
                    children: [
                        {
                            path: '',
                            name: 'Remissions List',
                            element: <RefundsList />,
                            index: true,
                        },
                        {
                            path: ':remissionId',
                            name: 'Remission',
                            element: <DepositDeclaration />,
                            index: true,
                        },
                    ],
                },
            ],
        },
        {
            path: 'vat-and-duty',
            name: 'VAT and Duty',
            element: <DeclarationVatAndDuty />,
        },
    ];
};

const getDeclarationRouteFlags = (declaration: Declaration | undefined) => {
    const isGvmsOrPbn = !!declaration?.gvmsDeclaration || !!declaration?.preBoardingNotification;
    const isIcs2Ens = !!declaration?.ics2ENSDeclaration;
    const isDeclarationLoaded = !!declaration;

    return {
        isGvmsOrPbn,
        isIcs2Ens,
        isIcs2EnsWithMasterItems: hasIcs2MasterItems(declaration),
        isDeclarationLoaded,
    };
};
